import { RequestService } from '../../../common/services/RequestService';
import { GET_MONETIZATION_TEMPLATES } from '../constants';

export const getMonetizationTemplatesRequest = async () => {
  const response = await RequestService.get(GET_MONETIZATION_TEMPLATES);
  return response && response.data
};
